<template>
  <div class="team">
    <div v-if="awardlist && awardlist.length > 0" class="team-wrap">
      <div v-for="(item,index) in awardlist" :key="index" class="team-item flex-row">
        <div class="team-item-left flex-column">
          <div class="team-item-left-name">{{item.award_name}}</div>
          <div class="team-item-left-date">有效期至{{activityInfo.end_time_format}}</div>
        </div>
        <div class="team-item-right flex-row">
          <div v-if="activityInfo.isover" class="team-item-right-btn">已过期</div>
          <div
            v-else-if="item.isused == 1 && item.code_type != 1"
            class="team-item-right-btn"
            :class="{'disabled':item.code_type != 1}"
            @click="goAward(item)"
          >{{item.code_type == 1 ? '查看' : '已使用'}}</div>
          <div
            v-else-if="_getBrowser() == 1"
            class="team-item-right-btn"
            @click="useAward(index)"
          >{{item.isused == 1 ? '查看' : '去使用'}}</div>
          <div
            v-else
            class="team-item-right-btn btn-clipboard"
            id="btnH5"
            @click="_downloadAPP(1,'team#use_appdownload')"
            data-clipboard-target="#hello"
          >{{item.isused == 1 ? '查看' : '去APP使用'}}</div>
          <input type="hidden" id="hello" value style="display:none;" />
          <!-- <img class="team-item-right-btn" src="../../static/images/team_btn.png" alt /> -->
        </div>
      </div>
      <div class="team-text">请在活动结束前全部领取</div>
    </div>
    <!-- 无列表 -->
    <div v-if="awardlist && awardlist.length <= 0" class="team-nolist flex-column">
      <img class="team-nolist-icon" src="../../static/images/icon_nolist.png" alt />
      <span>空空如也</span>
      <img @click="goVow" class="team-nolist-btn" src="../../static/images/vow_btn2.png" alt />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// import Alert from "../components/Alert";
import { List } from "vant";
Vue.use(List);
export default {
  name: "team",
  urlData: null,
  data() {
    return {
      firstloading: false,
      isapp: false,
      pageIndex: 0,
      awardlist: null,
      complete: false,
      van_list_load: false,
      // 规则的初始显示状态
      showRule: false
    };
  },
  methods: {
    // 使用说明
    useClick(i) {
      var t = this;
      t.awardlist[i].isShow = !t.awardlist[i].isShow;
      if (t.awardlist[i].isShow) {
        t._deepmain(t.pageId, "activity#reward#instruction", 2);
      }
    },
    // 隐藏奖励
    hideModel() {
      var t = this;
      t.alt.showmodel = !t.alt.showmodel;
    },

    //获得我的中奖记录
    getteams() {
      var t = this;
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "加载中..."
      });
      var params = {
        activity_id: t._getAPPParams().activity_id
      };
      console.log(params);
      t._get("user", "User.getAwardLog", params)
        .then(res => {
          if (res.status == 0) {
            var list = res.data.award_list;
            for (var i = 0; i < list.length; i++) {
              // var rule = list[i].award_info.use_desc;
              // if (rule) {
              //   rule = rule.replace(/[\d]+\./g, "");
              //   rule = rule.split("\n");
              // }
              // list[i].award_info.use_desc = rule;
              // list[i].isShow = false;
              list[i].isOver = new Date(list[i].expires_code_t) <= new Date();
              if (list[i].isOver) list[i].status = 2;
            }

            t.awardlist = list.sort(function(a, b) {
              return a.status - b.status;
            });
            t.complete = true;
          } else {
            t.complete = true;
          }
          t.van_list_load = false;
          t.firstloading = true;
          loading.clear();
        })
        .catch(error => {
          t.van_list_load = false;
          console.log(`error is:${error}`);
          loading.clear();
        });
    },
    //立即使用
    useAward(index) {
      var t = this;
      t._deepmain(t.pageId, "activity#reward#use", 2, function() {
        var info = t.awardlist[index];
        console.log("use award info", info);
        // if (info.issku == 1) {
        //   t.activeSku(index);
        //   return;
        // }
        // var loading = null;
        // setTimeout(() => {
        //   if (!loading)
        //     loading = t.$Toast.loading({
        //       duration: 0, // 持续展示 toast
        //       forbidClick: true, // 禁用背景点击
        //       mask: true,
        //       message: "加载中..."
        //     });
        // }, 200);

        var params = {
          aid: info.id
        };
        console.log(params);
        t._get("user", "User.activeAward", params)
          .then(res => {
            // if (loading) loading.clear();
            // loading = "stop";
            // <el-radio-group v-model="form.code_type">
            //   <el-radio label="0">券码(无需跳转)</el-radio>
            //   <el-radio label="1">短链接(跳转)</el-radio>
            //   <el-radio label="2">二维码/条形码</el-radio>
            //   <el-radio label="3">sku</el-radio>
            //   <el-radio label="4">直充</el-radio>
            // </el-radio-group>;

            if (res.status == "0") {
              t.$toast("领取成功");
              t.awardlist[index].isused = 1;
              t.goAward(info);
            } else {
              t.$toast(res.msg);
            }
          })
          .catch(error => {
            console.log(`error:${error}`);
            // if (loading) loading.clear();
            // loading = "stop";
          });
      });
    },
    // 处理跳转，已领取的也可以跳转
    goAward(info) {
      var t = this;
      console.log("[nosku]go award", info);
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "正在跳转..."
      });
      //sku奖品
      if (info.code_type == 3) {
        console.log("---打开优惠券列表---");
        try {
          Jegotrip.openRnPage(
            JSON.stringify({ funType: "couponsview", funParams: {} })
          );
        } catch (e) {
          // t.$Toast("网络不给力，请稍后再试");
        }
        loading.clear();
      }
      // 券码链接
      if (info.code_type == 1) {
        var re_href = info.award_code;
        if (re_href.indexOf("://") < 0) re_href = "http://" + info.award_code;
        window.location.href = re_href;
        loading.clear();
      }
    },

    //无忧行自营商品
    activeSku(index) {
      var t = this;
      var info = t.awardlist[index];
      console.log("[sku]active", info);
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "加载中..."
      });
      var params = {
        award_log_id: info.id
      };
      console.log(params);
      t._get("user", "User.activeSku", params)
        .then(res => {
          loading.clear();
          if (res.status == 0) {
            t.$toast("领取成功");
            t.awardlist[index].status = 1;
            console.log("---打开优惠券列表---");
            try {
              Jegotrip.openRnPage(
                JSON.stringify({ funType: "couponsview", funParams: {} })
              );
            } catch (e) {
              this.$Toast("网络不给力，请稍后再试");
            }
          } else {
            t.$toast(res.msg);
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },

    tohome() {
      var t = this;
      t.$router.push({
        path: "/home",
        query: {}
      });
      t._deepmain(t.pageId, "activity#reward#play", 2);
    },
    goVow() {
      var t = this;
      t.$router.push({
        path: "/newvow",
        query: {}
      });
      t._deepmain(t.pageId, "homepage1#award_makewish", 2);
    }
  },
  components: {
    
  },
  computed: {
    myawardlist: function(awardlist) {
      var t = this;
      // console.log(t.awardlist);
      return awardlist.sort(function(a, b) {
        return a.status - b.status;
      });
    }
  },
  created() {
    var t = this;
    var userAgent = window.navigator.userAgent.toLowerCase();
    this.isapp = userAgent.match(/jegotrip/i) == "jegotrip";
    t.urlData = t.$route.query;
    console.log("t.urlData", t.urlData);
    t.getteams();
  }
};
</script>

<style scoped  lang="scss" src="../../static/scss/team.scss"></style>




<!-- Add "scoped" attribute to limit CSS to this component only -->
